export const PRICE_REVIEW = "price_review"
export const INITIATED_BY_USER = "initiated_by_user"
export const ACTIVE = "active"
export const CANCELLED = "canceled"
export const COMPLETED = "completed"
export const PAID = "paid"
export const PAID_AT_SHOP = "paid_at_shop"
export const IN_MANUAL_REVIEW = "in_manual_review"
export const APPROVAL = "approval"
export const AWAITING_APPROVAL = "awaiting_approval"
export const WALK_IN = "walk_in"

export const PAID_STATUSES = [PAID, PAID_AT_SHOP, IN_MANUAL_REVIEW]

export const NOTIFICATION_STATUS_CHANGE = 'status_change'
export const NOTIFICATION_ORDER_CREATED = 'order_created'

export const DETAILS_TAB = "details"
export const SERVICES_TAB = "services"
export const NOTES_TAB = "notes"
export const ISSUES_TAB = "issues"
export const INVOICE_TAB = "invoice"
export const TRANSACTIONS_TAB = "transaction"
export const LINE_ITEMS_TAB = "line_items"
